import type { ActivityTimelineFeed } from "../../../../types";
import { useGetDocumentsByEntity } from "../../api/useGetDocumentsByEntity";

type Props = {
  item: ActivityTimelineFeed;
};

export function useActivityTimelineDocumentsList(props: Props) {
  const filter = {
    communicationId: props.item.entity_type === 'communication' ? props.item.id ?? undefined : undefined,
    quoteId: props.item.entity_type === 'quote' ? props.item.id ?? undefined : undefined,
    incidentId: props.item.entity_type === 'incident' ? props.item.id ?? undefined : undefined,
    eventId: props.item.entity_type === 'event' ? props.item.id ?? undefined : undefined,
    documentId: props.item.entity_type === 'document' ? props.item.id ?? undefined : undefined,
    subjectActionId: props.item.id ?? undefined,
  };

  const { data: documents, isLoading } = useGetDocumentsByEntity(filter, !!props.item.has_documents);

  return {
    documents: documents ?? [],
    isLoading,
  };
}
